// removed by extract-text-webpack-plugin
module.exports = {"textDanger":"_3cLyxrc5zQhWCBsW4cBjJM","spaceLeft":"_1UCvGY_Fb9rbdGQks7fH1I","spaceBoth":"_3UT__XgCcLGUa2C6hebFYa","spaceRight":"_1pslM-KDD21Vs4a86NxQAf","footer":"_2huZMvqtVRNvbXBUVQBZ_i"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/OasisMakeOfferModal.scss
// module id = 476
// module chunks = 0